import { Box } from '@mui/material';
import { Badge } from 'framework/ui/mui-builder';

interface CountBadgesProps {
  changesCount: number;
  staleItemsCount: number;
}

const CountBadges = ({ changesCount, staleItemsCount }: CountBadgesProps) => (
  <Box display="flex" alignItems="center" gap={1}>
    {!!changesCount && <Badge color="warning">{changesCount} changes</Badge>}
    {!!staleItemsCount && (
      <Badge color="error">
        {staleItemsCount} {staleItemsCount === 1 ? 'stale item' : 'stale items'}
      </Badge>
    )}
  </Box>
);

export default CountBadges;
